import React from 'react';
import get from 'get-value';
import classNames from 'classnames';
import Input from 'shared/Inputs/Input';
import { BUTTON_MODS } from '../interface';
import './_FormInputNewUi.scss';
import Button from 'shared/Button/Button';

type Props = {
  mode: BUTTON_MODS;
  field: any;
  form: any;
};

const FormInputNewUi: React.FC<Props> = ({ field, form, mode = BUTTON_MODS.CHANGE, ...props }) => {
  const { name } = field;
  const { touched, errors } = form;
  const {
    label,
    labelClass = 'form__label',
    inputClass = 'form__input',
    helperText,
    placeholder,
    wrapperClass = 'form__wrapper_newUi inline',
    showBorder = true,
    mask,
    showMask = false,
    handleBlur,
    readOnly,
    onChangeClick,
    buttonClass = '',
    disabled,
    error = '',
  } = props as any;

  const changeButtonText = BUTTON_MODS[mode];

  const inputWrapperClass = 'form-input-inline';
  const nestedError = get(errors, name);
  const nestedTouched = get(touched, name);

  const hasError = error || (nestedTouched && nestedError);
  const errorMessage = error || nestedError;

  const containerClass = classNames(wrapperClass, {
    'form__field-error': error || (nestedTouched && nestedError),
    'no-border': !showBorder,
  });

  const buttonClassName = classNames('button', buttonClass);

  const handleChangeClick = (...props: any) => {
    onChangeClick(mode === BUTTON_MODS.CHANGE ? BUTTON_MODS.OK : BUTTON_MODS.CHANGE, ...props);
  };

  return (
    <div className={containerClass}>
      <div className={inputWrapperClass}>
        <div className="row">
          <label htmlFor={name} className={`${labelClass} form__inline-label`}>
            {label}
          </label>

          {helperText && <div className="form__helper-text">{helperText}</div>}
          <div className="grid">
            <div className="grid__item">
              <Input
                id={name}
                {...field}
                field={field}
                className={`${inputClass} ${inputClass}--row`}
                placeholder={placeholder}
                mask={mask}
                fieldName={field.name}
                form={form}
                showMask={showMask}
                handleBlur={handleBlur}
                readOnly={readOnly}
                disabled={disabled}
              />
            </div>
            {onChangeClick && (
              <div className="grid__item">
                <Button onClick={handleChangeClick} label={changeButtonText} className={buttonClassName} />
              </div>
            )}
          </div>
        </div>
        {hasError && <div className="error">{errorMessage}</div>}
      </div>
    </div>
  );
};

export default FormInputNewUi;
